import * as React from "react";
import { Create, SimpleForm, TextInput, SelectInput, required, useDataProvider } from "react-admin";
import { useClub } from "../club/ClubContext";

const getClubId = () => 1;

export function UserInvite() {
  const dataProvider = useDataProvider();
  const [choices, setChoices] = React.useState<{ id: string; name: string }[]>([]);
  const [clubs, setClubs] = React.useState<{ id: string; display_name: string }[]>([]);
  const { clubId } = useClub();

  React.useEffect(() => {
    (async () => {
      const res: any = await dataProvider.getList("assignableRoles", {
        pagination: { page: 1, perPage: 100 },
        sort: { field: "id", order: "ASC" },
      });

      setChoices(res.data); // [{id,name}, ...]
    })().catch((e) => {
      console.error("roles load failed", e);
      setChoices([]);
    });
  }, [dataProvider]);

  React.useEffect(() => {
    (async () => {
      const res: any = await dataProvider.getList("assignableClubs", {
        pagination: { page: 1, perPage: 100 },
        sort: { field: "id", order: "ASC" },
      });
      setClubs(res.data); // [{id,name}, ...]
    })().catch((e) => {
      console.error("clubs load failed", e);
      setClubs([]);
    });
  }, [dataProvider]);

  return (
    <Create>
      <SimpleForm defaultValues={{ clubs: clubId }}>
        <TextInput source="email" validate={[required()]} fullWidth />
        <TextInput source="first_name" fullWidth />
        <TextInput source="last_name" fullWidth />
        <TextInput source="clubs" sx={{ display: "none" }} />

        <SelectInput
          source="role"
          choices={choices}
          optionText="name"
          optionValue="id"
          validate={[required()]}
          fullWidth
        />
      </SimpleForm>
    </Create>
  );
}
